import {Filtro} from './filtro';
import {RotaVo} from '../../vo/rota-vo';

export class FiltroNome implements Filtro<RotaVo> {

  private comparadores: string[];

  constructor(
    comparadores: string[]
  ) {
    this.comparadores = comparadores;
  }

  filtrar(array: RotaVo[]): RotaVo[] {
    // Cada comparador (chip) restringe o resultado (E entre chips): a rota precisa
    // atender todos, cada um podendo bater em nome, placa, motorista ou identificador
    return this.comparadores.reduce((resultado, comparador) => {
      const termo = comparador.toLowerCase();
      return resultado.filter((obj) =>
        (obj.nome ?? '').toLowerCase().includes(termo) ||
        (obj.placa ?? '').toLowerCase().includes(termo) ||
        (obj.motorista ?? '').toLowerCase().includes(termo) ||
        (obj.identificador ?? '').toLowerCase().includes(termo)
      );
    }, array);
  }

  getFiltroNome(): string {
    return 'nome';
  }

  getComparador(comparador: string): string {
    return this.comparadores.find((obj) => obj === comparador) || '';
  }

  getComparadores(): string[] {
    return this.comparadores;
  }

  addComparador(comparador: string): void {
    this.comparadores = this.comparadores.concat(comparador);
  }

  addComparadores(comparadores: string[]): void {
    this.comparadores = this.comparadores.concat(comparadores);
  }

  setComparadores(comparadores: string[]): void {
    this.comparadores = comparadores || [];
  }

}
